import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';

export const PreviousJobReportingStructureForm = ({ handleChange, job, index, handleBlur, errors, touched }) => {
  return (
    <div className="signite-form">
      <Row className="mb-3">
        <BSForm.Group as={Col}>
          <BSForm.Label>Reporting to</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`previousJobs.${index}.reportingTo`}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.reportingTo`)}`}
            value={job.reportingTo}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.reportingTo`)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>No.of Reportees</BSForm.Label>
          <BSForm.Control
            type="number"
            name={`previousJobs.${index}.numberOfReportees`}
            onChange={handleChange}
            onBlur={handleBlur}
            min={0}
            max={2147483647}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.numberOfReportees`)}`}
            value={job.numberOfReportees}
          />
          <span className="errorMessage">
            {getErrorMessage(errors, touched, `previousJobs.${index}.numberOfReportees`)}
          </span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>Team Size</BSForm.Label>
          <BSForm.Control
            type="number"
            min={0}
            name={`previousJobs.${index}.teamSize`}
            onChange={handleChange}
            value={job.teamSize}
            max={2147483647}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.teamSize`)}</span>
        </BSForm.Group>
      </Row>
    </div>
  );
};